import React,{useState, useEffect} from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import {Inc,Story,Play,ResultSet} from './Inc';
import Ajax from './Ajax';
import Dial from './Dial';
import Roll from './Roll';
import Greeting from './Greeting';
import Loading from './Loading';
import './Board.scss';

interface Props {
    uid:string,
    save(id:string):void,
    move(str:string,story:any):void,
    story:Story;
    play:Play,
}

const Board = (props:Props)=> {
    Ajax.setUid(props.uid);
    const defLines:string[] = [];
    const [states,setStates] = useState({
        story_id: 0,
        lines:defLines,
        step:-1,
        start:0,
        isEnd: false,
        isLoading:false,
        result:Inc.defaultResultSet(),
    });
    const next = ()=>{
        if( states.lines.length>states.step+1 ){
            setStates({...states,step:states.step+1});
        } else {
            const dt = new Date();
            const score = dt.getTime() - states.start;
            //setStates({...states,isEnd:true});
            Ajax.send("play/close",{id:props.play.id,score:score},(res:any)=>{
                //console.log("close",res);
                if( res.ok ){
                    const result:ResultSet = {
                        story:res.story,
                        play:res.play,
                        is_suki:res.is_suki,
                    }
                    setStates({...states,isEnd:true,result:result});
                }
            });
            
        }
    }
    const start = ()=>{
        const dt = new Date()
        setStates({...states,step:0,start:dt.getTime()});
    }
    const goResult = ()=>{
        props.move("result",states.result);
    }

    useEffect( ()=>{
        const tmp = props.story.lines.split("\n");
        let lines = [];
        for( let i=0 ; i<tmp.length ; i++ ){
            if( tmp[i].trim()!=="" ){
                lines.push( tmp[i].trim() );
            }
        }
        setStates({...states,"lines":lines,"story_id":props.story.id});
    },[]);

    if( states.lines.length===0 ){
        return (null);
    }

    let completed = 0;
    let buffer = 0;
    if( states.isEnd ){
        completed = 100 ;
        buffer = 100 * states.step/states.lines.length;
    } else if( states.step>0 ){
        completed = 100 * states.step/states.lines.length;
        buffer = 100 * (states.step-1)/states.lines.length;
    }

    return (
		<div id="board">
            {states.step===-1 ? (
            <Greeting next={start}/>
            ):(
            <React.Fragment>
                {!states.isEnd ?(
                <Dial text={states.lines[states.step]} next={next} step={states.step}/>
                ):(
                <Roll score={states.result.play.score} title={props.story.title} next={goResult}/>
                )}
                <div className="progress">
                    <LinearProgress color="secondary" variant="buffer" value={completed} valueBuffer={buffer} />
                </div>
            </React.Fragment>
            )}
            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default Board;